module.exports = __webpack_public_path__ + "img/logo-donedone.5284d638.svg";